/** 统一走线上 API（本地 dev、Vercel Preview、生产部署一致，避免误打本机 / 相对路径） */
const API_ORIGIN = "https://api.xtool.chat";

export function getApiOrigin(): string {
  return API_ORIGIN;
}

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${API_ORIGIN}${p}`;
}

/** 跨域直连线上时不用带 cookie，避免 CORS credentials 限制 */
export function adminFetchCredentials(): RequestCredentials {
  if (typeof window === "undefined") return "same-origin";
  try {
    if (API_ORIGIN === window.location.origin) return "same-origin";
  } catch {
    /* ignore */
  }
  return "omit";
}
